import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MaterialSelect from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

// Helper
import profileMenu from "StaticData/Dashboard/profile";
import { routes } from "Library/Constants";

// Component
import ProfileComponent from "./ProfileComponent";

//images
import images from "Assets/images";

//css
import "Assets/css/style.css";
import "./style.css";
import "Assets/css/common.css";
import "Assets/css/booking-list.css";
import "Assets/css/booking-form.css";
import "Assets/css/site-management.css";
import "Assets/css/global-admin.css";
import "Assets/css/cutstmize.css";
import { useDashboardSettings } from "Hooks/useDashboardSettings";
import { useAuth } from "Hooks/useAuth";
import AccountMenu from "Components/UI/AccountMenu";
import icons from "Assets/images/icons";
import { CHOOSE_PLATFORM_PAGE } from "Network/ApiUrl";
import { useTranslation } from "react-i18next";

const index = () => {
  const { t } = useTranslation();
  const [showNotification, setNotification] = useState(false); // Need in future
  const [showProfile, setShowProfile] = useState(false);
  const wrapperNotificationRef = useRef(null);
  const wrapperProfileRef = useRef(null);
  const navigate = useNavigate();

  const {
    platforms,
    selectedPlatform,
    regions,
    selectedRegion,
    onPlatformChange,
    onRegionChange,
  } = useDashboardSettings();
  const { userData, logout } = useAuth();
  const initials = userData
    ? userData?.firstName?.charAt(0) + userData?.lastName?.charAt(0)
    : "NA";

  const handleClickProfileIcon = () => {
    setShowProfile(!showProfile);
  };
  function useOutsideAlerter(ref: any) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event: Event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setNotification(false);
          setShowProfile(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(wrapperNotificationRef);
  useOutsideAlerter(wrapperProfileRef);

  return (
    <>
      <div className="top-header">
        <div className="header-logo" style={{ width: "220px" }}>
          <Link className="sidebar-brand" to={routes.dashboardNav.projects()}>
            <img src={images.logoMini} alt="logo" className="logo-mini" />
            <img src={images.logogreenSvg} alt="logo" className="logo" />
          </Link>
        </div>
        <div className="header-navbar">
          <nav className="navbar navbar-expand navbar-light topbar static-top">
            <form
              style={{ display: "flex", flexDirection: "row", gap: "10px" }}
            >
              <div className="form-group mb-0">
                <MaterialSelect
                  style={{
                    width: "350px",
                    height: "45px",
                    background: "#232d38",
                    color: "white",
                  }}
                  value={selectedPlatform?.id}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 233,
                        width: 250,
                        background: "#232d38",
                        color: "white",
                      },
                    },
                  }}
                  onChange={(e) => onPlatformChange(Number(e.target.value))}
                >
                  {platforms?.map((item) => (
                    <MenuItem
                      value={item?.id}
                      key={item?.id}
                      disabled={!item?.code}
                    >
                      <div className="custm-header-select">
                        <div className="select-img-icon">
                          <div className="select-project-text">{item.name}</div>
                        </div>
                      </div>
                    </MenuItem>
                  ))}
                </MaterialSelect>
              </div>
              <div className="form-group mb-0">
                <MaterialSelect
                  style={{
                    width: "200px",
                    height: "45px",
                    background: "#232d38",
                    color: "white",
                    marginLeft: 10,
                  }}
                  value={selectedRegion?.id}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 233,
                        width: 250,
                        background: "#232d38",
                        color: "white",
                      },
                    },
                  }}
                  onChange={(e) => onRegionChange(Number(e.target.value))}
                >
                  {regions?.map((item) => (
                    <MenuItem value={item?.id} key={item?.id}>
                      <div className="custm-header-select">
                        <div className="select-img-icon">
                          <div className="select-project-text">{item.name}</div>
                        </div>
                      </div>
                    </MenuItem>
                  ))}
                </MaterialSelect>
              </div>
            </form>

            <AccountMenu
              initials={initials}
              options={[
                {
                  Icon: icons.Profile,
                  label: t("Translation.my_account"),
                  onClick: () => {
                    navigate(routes.dashboardNav.account());
                  },
                },
                {
                  Icon: icons.Component,
                  label: t("Translation.select_platform"),
                  onClick: () => {
                    window.location.href = CHOOSE_PLATFORM_PAGE;
                  },
                },
                {
                  Icon: icons.LogoutCircle,
                  label: t("Translation.logout"),
                  onClick: logout,
                },
              ]}
            />
          </nav>
        </div>
      </div>
    </>
  );
};

export default index;
